
import Headersection from './Component/HeaderTop/Headersection';
import Partners from './Component/Partners/Partners';
import '@fortawesome/fontawesome-free/css/all.min.css';
import One from './Component/One/One';
import Savings from './Component/Savings/Savings';
import Create from './Component/Create/Create';
import Trust from './Component/Trust/Trust';
import Pricing from './Component/Pricing/Pricing';
import Testimonial from './Component/Testimonial/Testimonial';
import Footer from './Component/Footer/Footer';
import Plans from './Component/Plans/Plans';
import Upgrade from './Component/Upgrade/Upgrade';
function App() {
  return (
    <div>
      <Headersection />
      <Partners />
      <Upgrade />
      <One />
      <Create />
      <Trust />
      <Savings />
      <Plans />
      {/* <Pricing /> */}
      <Testimonial />
      <Footer />
    </div>
  );
}

export default App;
